module.exports = __webpack_public_path__ + "static/img/周金阳.94177a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lbtuimaj/周金阳.jpg
// module id = yOUB
// module chunks = 1